import { sessionListHost } from '@/composition/hosts/session/session-list/session-list-host';
import {
  deleteSessionDataAtom,
  deleteTranscriptDataAtom,
  isBulkCreatingSessionsAtom,
  isUploadScheduleUnsavedAlertDialogOpenAtom,
  isUploadSessionScheduleModalOpenAtom,
  LazyUploadSessionScheduleModal,
  useBeforeUnloadWarning,
} from '@heidi/session';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { useState } from 'react';

// App composition owns lazy mounting; existing domain implementations keep their
// established paths and mutation dependencies.
const DeleteSessionModalImplementation = dynamic(
  () => import('@/components/modal/delete-session-modal'),
  {
    ssr: false,
    loading: ({ error }) => {
      if (error) throw error;
      return null;
    },
  }
);

export function DeleteSessionModal() {
  const isOpen = Boolean(useAtomValue(deleteSessionDataAtom));
  const [isDeleting, setIsDeleting] = useState(false);
  // A closed dialog may still own an in-flight mutation. Retain its observer
  // so reopening cannot enable a second delete before the first settles.
  if (!isOpen && !isDeleting) return null;
  return <DeleteSessionModalImplementation onPendingChange={setIsDeleting} />;
}

const DeleteTranscriptModalImplementation = dynamic(
  () => import('@/components/modal/delete-transcript-modal'),
  {
    ssr: false,
    loading: ({ error }) => {
      if (error) throw error;
      return null;
    },
  }
);

export function DeleteTranscriptModal() {
  const isOpen = Boolean(useAtomValue(deleteTranscriptDataAtom));
  const [isDeleting, setIsDeleting] = useState(false);
  // A closed dialog may still own an in-flight mutation. Retain its observer
  // so reopening cannot enable a second delete before the first settles.
  if (!isOpen && !isDeleting) return null;
  return <DeleteTranscriptModalImplementation onPendingChange={setIsDeleting} />;
}

export const UploadSessionScheduleModal = () => {
  const isOpen = useAtomValue(isUploadSessionScheduleModalOpenAtom);
  const isConfirmingDiscard = useAtomValue(isUploadScheduleUnsavedAlertDialogOpenAtom);
  const isBulkCreating = useAtomValue(isBulkCreatingSessionsAtom);
  // Drafts may survive closing the dialog. Keep their navigation guard mounted.
  useBeforeUnloadWarning();
  if (!isOpen && !isConfirmingDiscard && !isBulkCreating) return null;
  return <LazyUploadSessionScheduleModal host={sessionListHost} />;
};
